import React, { useContext, useRef, useState } from 'react'
import MyContext from '../../../context/MyContext'
import Lottie from 'lottie-web'
//import Lottie from 'react-lottie';
import AuthContext from '../../../context/userAuth.context';
import axios from 'axios';
import TickerContext from '../../../context/ticker';
const DraggedImg = (props) => {

  const parent = useRef(null)
  const image = useRef(null)

  const { timelineZoomVal, setLayersData, LayersData, calculateTimeByWidth, clone, setRedoLayer, UndoLayer, setUndoLayer, calculateWidthByDuration, ChangeCount,
    setChangeCount, Tl_TotalTime } = useContext(MyContext)

  const { TickerPosition } = useContext(TickerContext)

  const { Loader, authenticationData } = useContext(AuthContext)

  const [LoaderState, setLoaderState] = useState(null)

  var ImageTop, ImageLeft, ImageUrl;

  const setImageData = (IUrl, ITop, ILeft, Iheight, ImageBlob, event) => {

    var stack = [...UndoLayer]
    var PrevArray

    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = []
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;

    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false
      if (LayersData[i].Editable === true) { LayersData[i].Editable = false }
      if (LayersData[i].type === 'image') { typelength = typelength + 1 }
      if (LayersData[i].key >= checkKey) { checkKey = LayersData[i].key }
    }

    let currentTime = calculateTimeByWidth(TickerPosition)
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition)

    let newEntryLayerData = {
      key: checkKey + 1,
      type: "image",
      bgColor: "#554bf5",
      Name: `image-${typelength}`,
      TimelineZoom: timelineZoomVal,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      duration: totalTime,
      startTime: currentTime,
      originalX: null,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      InClass: '',
      OutClass: '',
      typeIcon: "vrpano",
      STdiff: null,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      angle: 0,
      ImageSrc: IUrl,
      crop: "false",
      lock: false,
      x: ILeft,
      y: ITop,
      flip: "scaleX(1)",
      width: 300,
      height: Iheight,
      toolbar: false,
      FurtherSetting: false,
      opacity: 1,
      layerlock: false,
      opc: 1,
      hidden: false,
      Editable: true,
      ImageBlob: ImageBlob,
      startPositionOnTimeline: TickerPosition,
      player: false,
      rotateAngle: 0,
      AzData: null,
      startAtoZ: false,
      InMultiDrag: false,
    };

    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(newEntryLayerData.duration);
    newEntryLayerData.endTransitionLeft = newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;

    setLayersData(LayersData.concat(newEntryLayerData));
    setChangeCount(ChangeCount + 1)

    Lottie.stop('loader')
    parent.current.style.display = 'none';
    image.current.style.left = '0px';
    image.current.style.top = '0px';
    //image.current.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  };

  var min_X, max_X, min_Y, max_Y = 0, leftStrip, EditorMargin, preIndex;

  const allowDrop = (e) => {

    min_X = document.getElementsByClassName('tdStyle1')[0].offsetWidth;
    max_X = min_X + document.getElementsByClassName('tdStyle2')[0].offsetWidth;
    min_Y = document.getElementsByClassName('navbarWrapper')[0].offsetHeight;
    max_Y = min_Y + document.getElementsByClassName('EditorTrackerStart')[0].offsetHeight;

    EditorMargin = Number(document.getElementsByClassName('EditorTrackerStart')[0].style.marginTop.split('px')[0])

    leftStrip = document.getElementsByClassName('leftDarkHiddden')[0].offsetWidth * 2
    if (e.pageX > min_X && e.pageX < max_X && e.pageY > min_Y && e.pageY < max_Y) {
      e.preventDefault();
    }
  }

  const drag = (e) => {
  }

  const handleDrop = (e) => {

    if (e.pageX > min_X && e.pageX < max_X && e.pageY > min_Y && e.pageY < max_Y) {

      var clientval = e.target.getBoundingClientRect();
      ImageUrl = e.target.attributes.picurl.value;
      var imageHeight = e.target.offsetHeight;
      ImageTop = (clientval.top - (min_Y + EditorMargin));
      ImageLeft = (clientval.left - (min_X + leftStrip));     //15 is the size of right scroll
      parent.current.style.top = e.target.style.top
      parent.current.style.left = e.target.style.left
      parent.current.style.width = e.target.offsetWidth + 'px'
      parent.current.style.height = e.target.offsetHeight + 'px'
      e.target.style.display = "none";
      parent.current.style.display = '';

      if (LoaderState === null) {
        const get = Lottie.loadAnimation({
          name: 'loader',
          container: parent.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: Loader // the path to the animation json
        });
        // get.setSpeed(2)
        setLoaderState(get)
      } else { LoaderState.play('loader') }
      ImageURLToBase64(ImageUrl).then(function (baseStr) {
        setImageData(baseStr, ImageTop, ImageLeft, imageHeight, null, e);
      }).catch(function () {
        setImageData(ImageUrl, ImageTop, ImageLeft, imageHeight, null, e);
      })

      // return loadImage(e.target.attributes.picurl.value).then(image => {
      //   setImageData(ImageUrl, ImageTop, ImageLeft, imageHeight, image, e);
      // });
    }
  }

  const ImageURLToBase64 = (url) => {

    return new Promise((resolve, reject) => {
      var splittedURL = url.split('/');
      var imageName = splittedURL[splittedURL.length - 1];
      var extension = imageName.split('.')[1];

      let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
      axios.get(authenticationData.ApiBaseURL + "/api/Images/ImageURLToBase64?url=" + url, {

        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + authData.access_token
        }

      }).then(response => {
        if (response.data != null && response.data != "") {
          var format = "data:image/jpeg;base64,";
          if (extension.toLowerCase() == "png") {
            format = "data:image/png;base64,";
          }
          var baseStr = format + response.data;

          resolve(baseStr)
        }
        else {
          reject()
        }
      }).catch(error => {
        reject()
      });
    })
  }


  var style = {
    display: 'none',
    left: "0px",
    top: "0px"
  }

  return (<>
    <div ref={parent} className='MyLoader' style={{ position: 'absolute', left: '0px', top: '0px' }} />
    <img ref={image} className="previewDragger" src={props.url} picurl="" alt="" style={style} onDragOver={allowDrop} onDrag={drag} onDrop={handleDrop} />
  </>)
}
export default DraggedImg;